module.exports = __webpack_public_path__ + "static/TheMetSans-Medium-49ef382673a1854d7cecf4132480f639.woff2";